import api from '../../api'
import wsAPI from '../../wsPromotionAPI'
import { endpoints } from '../../apiCommons'
import localCompany from '../localStorage/localCompany'
const formatTop = (res) => {
  const total = res.data.reduce((acc, el) => acc + el.nCant, 0)
  return {
    total,
    data: res.data.map((item) => {
      return {
        ...item,
        nCant: (total / item.nCant) * 100,
      }
    }),
  }
}

const InfoDashboar = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()

  return api.get(endpoints.cards, {
    params: { sEmpresa },
    headers: {
      token,
    },
  })
}
const getCategories = async (sEmpresa) => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.foodCategories, {
    params: { sEmpresa },
    headers: { token },
  })
}

const getConsumption = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.dashboardConsumption, {
    params: {
      sEmpresa,
      bAnterion: 'true',
    },
    headers: { token },
  })
}

const topEcoFriendly = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api
    .get(endpoints.topEcoFriendly, {
      params: {
        sEmpresa,
      },
      headers: { token },
    })
    .then((res) => {
      return formatTop(res)
    })
}
const topLocalesBarrio = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api
    .get(endpoints.topLocalesBarrio, {
      params: {
        sEmpresa,
      },
      headers: { token },
    })
    .then((res) => {
      return formatTop(res)
    })
}

const promotions = async () => {
  const token = localStorage.getItem('token')
  const { user } = localCompany.getUserData()

  return wsAPI.get(endpoints.promotions, {
    params: {
      sComuna: user.sComuna,
    },
    headers: { token },
  })
}

const digitalTransactions = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.digitalTransactions, {
    params: {
      sEmpresa,
    },
    headers: { token },
  })
}

const NewLocales = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.NewLocales, {
    params: {
      sEmpresa,
    },
    headers: { token },
  })
}

const SolicitudContactoGiftCard = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()

  return api.get(endpoints.SolicitudContactoGiftCard, {
    params: {
      sEmpresa,
    },
    headers: { token },
  })
}

const IndicadorDigitalizacion = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()

  return api.get(endpoints.IndicadorDigitalizacion, {
    params: {
      sEmpresa,
    },
    headers: { token },
  })
}

const SolicitudContactoDigital = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()

  return api.get(endpoints.SolicitudContactoDigital, {
    params: {
      sEmpresa,
    },
    headers: { token },
  })
}

const EmpresaSolicitudComercio = async (body) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()

  return api.post(
    endpoints.EmpresaSolicitudComercio,
    { ...body, sEmpresa },
    {
      headers: { token },
    },
  )
}

const EmpresaSolicitudEmpresa = async (body) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()

  return api.post(
    endpoints.EmpresaSolicitudEmpresa,
    { ...body, sEmpresa },
    {
      headers: { token },
    },
  )
}

const SolicitudContactoSalaCuna = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()

  return api.get(endpoints.SolicitudContactoSalaCuna, {
    params: {
      sEmpresa,
    },
    headers: { token },
  })
}

export default {
  getCardsData: InfoDashboar,
  getCategories,
  getConsumption,
  topEcoFriendly,
  topLocalesBarrio,
  promotions,
  digitalTransactions,
  NewLocales,
  SolicitudContactoGiftCard,
  IndicadorDigitalizacion,
  SolicitudContactoDigital,
  EmpresaSolicitudComercio,
  EmpresaSolicitudEmpresa,
  SolicitudContactoSalaCuna,
}
